import { useContext } from "react";
import goTo from "../../../../controllers/goTo";
import parseDate from "../../../../controllers/parseDate";
import CardForItem from "../../../customUiForCs/CardForItem";
import Context from "../../../../Context";

export default function CommentCard({ data, entireResponse, callback }) {
  let title = "";

  let line1 = [
    {
      text: `${parseDate(data.createdAt)}`,
    },
  ];

  let smallerTitle = data.text;

  let tertiaryBubbleLine = [];

  // if (data.author) {
  //   tertiaryBubbleLine = [
  //     {
  //       onClick: goTo(`/employee/${data.author._id}`),
  //       text: `By: ${data.author.lastName} ${data.author.firstName}`,
  //     },
  //   ];
  // }

  if (data.profile && data.author) {
    // tertiaryBubbleLine = [
    //   {
    //     onClick: goTo(`/employee/${data.profile._id}`),
    //     text: `Main Recipient: ${data.profile.lastName} ${data.profile.firstName}`,
    //   },
    //   {
    //     onClick: goTo(`/employee/${data.author._id}`),
    //     text: `Comment Author: ${data.author.lastName} ${data.author.firstName}`,
    //   },
    // ];

    title = `Concerné : ${data.profile.lastName} ${data.profile.firstName} (${data.profile.registrationNumber})`;

    smallerTitle = `${data.author.lastName} ${data.author.firstName} : ${data.text}`;
  }

  let line2 = null;

  if (data.site) {
    if (!line2) line2 = [];
    // line2.push({ text: `Nom de code: ${data.site.placeName}` });

    tertiaryBubbleLine.push({
      onClick: goTo(`/site/${data.site._id}`),
      text: `${data.site.placeName}`,
    });
  }

  if (data.zone) {
    // if (!line2) line2 = [];
    // line2.push({ text: `Zoulou: ${data.zone.name}` });

    tertiaryBubbleLine.push({
      onClick: goTo(`/zone/${data.zone._id}`),
      text: `${data.zone.name}`,
    });
  }

  if (entireResponse.commentsSeenAt) {
    let isNew = dateOneIsNewer(data.createdAt, entireResponse.commentsSeenAt);

    if (isNew) {
      tertiaryBubbleLine.push({ text: `Nouvelle`, highlight: true });
    }
  }

  function dateOneIsNewer(dateStr1, dateStr2) {
    const date1 = new Date(dateStr1);
    const date2 = new Date(dateStr2);

    if (date1 > date2) {
      return true;
    } else if (date2 > date1) {
      return false;
    }
  }

  return (
    <CardForItem
      title={title}
      callback={callback}
      smallerTitle={smallerTitle}
      // absolutePath={`/employee/${data.subjectID}`}
      tertiaryBubbleLine={tertiaryBubbleLine}
      itemType={"COMMENT"}
      line1={line1}
      line2={line2}
      editPath="edit-comment"
      pagePath={null}
      itemID={data._id}
    />
  );
}
